/* eslint-disable react/jsx-curly-newline */
/* eslint-disable import/order */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useQuery, useQueryClient } from "react-query";

import { updateConfigurationApi } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import {
  selectUpdateConfiguration,
  setUpdatingConfiguration,
  updateConfiguration
} from "../../../Common/store/slices/common";

import Stepper from "shared-components/lib/iac-stepper";
import {
  selectIntegratedDrivesAxes,
  selectIntegratedDrivesConfiguration,
  selectIntegratedDrivesCurrentStep,
  selectIntegratedDrivesSteps,
  selectReadOnlyMode,
  setIntegratedDrivesCurrentStep
} from "../../../IntegratedDrives/store/slices/integrated_drives";

/**
 * Sub header of the app.
 */
const IntegratedDrivesStepper = () => {
  const steps = useSelector(selectIntegratedDrivesSteps);
  const currentStep = useSelector(selectIntegratedDrivesCurrentStep);
  const configuration = useSelector(selectIntegratedDrivesConfiguration);
  const dispatch = useDispatch();

  const runUpdateConfiguration = useSelector(selectUpdateConfiguration);

  const modeReadOnly = useSelector(selectReadOnlyMode);
  const queryClient = useQueryClient();

  const [savedConfigurationPayload, setSavedConfigurationPayload] = useState(null);

  const {
    refetch: execUpdateConfiguration,
    isLoading,
    isFetching
  } = useQuery(
    "UPDATE_INTEGRATED_DRIVES_CONFIGURATION",
    async () => {
      try {
        if (JSON.stringify(savedConfigurationPayload) !== JSON.stringify(configuration.configData)) {
          setSavedConfigurationPayload(configuration.configData);

          const updatedConfig = (await updateConfigurationApi(configuration.configId, configuration.configData)) || {};
          return updatedConfig;
        }

        return null;
      } catch (error) {
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    dispatch(setUpdatingConfiguration(isLoading || isFetching));
  }, [isLoading, isFetching]);

  useEffect(() => {
    if (configuration?.configId && currentStep && !modeReadOnly) {
      // console.log("Configuration changed => update CONF");
      queryClient.cancelQueries("UPDATE_CONFIGURATION");
      execUpdateConfiguration();
    }
  }, [runUpdateConfiguration, configuration]);

  const axes = useSelector(selectIntegratedDrivesAxes);

  const isSelectAndConfigureValid = () => axes.every((axis) => axis.bundle);

  const handleGoToSelectAndConfigure = () => {
    dispatch(setIntegratedDrivesCurrentStep(steps.SPECIFY_AND_CONFIGURE));
    dispatch(updateConfiguration());
  };

  const handleGoToFinalize = () => {
    if (isSelectAndConfigureValid()) {
      dispatch(setIntegratedDrivesCurrentStep(steps.FINALIZE));
      dispatch(updateConfiguration());
    }
  };

  const IntegratedDrivesStepper = currentStep !== steps.START && (
    <>
      <Stepper
        steps={[
          {
            action: () => handleGoToSelectAndConfigure(),
            active: true,
            done: isSelectAndConfigureValid(),
            hidden: false,
            id: "SPECIFY_AND_CONFIGURE",
            isActiveStep: currentStep === steps.SPECIFY_AND_CONFIGURE,
            isActive: currentStep === steps.SPECIFY_AND_CONFIGURE,
            name: steps.SPECIFY_AND_CONFIGURE.label,
            order: 1,
            skipped: false,
            subLabel:
              currentStep === steps.SPECIFY_AND_CONFIGURE
                ? t("msizer.ui.stepper.in_progress")
                : t("msizer.ui.stepper.done")
          },
          {
            action: () => handleGoToFinalize(),
            active: isSelectAndConfigureValid(),
            done: currentStep === steps.FINALIZE,
            hidden: false,
            id: "FINALIZE",
            isActiveStep: currentStep === steps.FINALIZE,
            isActive: currentStep === steps.FINALIZE,
            name: steps.FINALIZE.label,
            order: 2,
            skipped: false,
            subLabel: currentStep === steps.FINALIZE ? t("msizer.ui.stepper.done") : t("msizer.ui.stepper.not_done")
          }
        ]}
        mobileBreakpoint={800}
        disabled={false}
      ></Stepper>
    </>
  );

  return IntegratedDrivesStepper;
};

IntegratedDrivesStepper.propTypes = {};

IntegratedDrivesStepper.defaultProps = {};

export default IntegratedDrivesStepper;
